import * as React from 'react';
import {
  Box,
  Paper,
  Chip,
  IconButton,
  Typography,
  Tooltip,
  Select,
  MenuItem,
  Popper,
  Button,
  ClickAwayListener
} from "@material-ui/core";
import {
  Add,
} from "@material-ui/icons"
import * as Utils from "@utils"
import styled from "styled-components"
import * as IconsGallery from "@iconsGallery"
import { makeStyles } from "@material-ui/core/styles"
import _ from "lodash"

const useStyles = makeStyles((theme) => ({
  ListBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    listStyle: 'none',
    alignItems: 'center',
    padding: 0,
    '@media(max-width:439px)': {
      overflowX: 'auto',
      // maxWidth: '100vw',
      display: 'flex',
      whiteSpace: 'nowrap',
    }
  },
  MenuPaper: {
    padding: '36px 20px 20px',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gap: '8px 10px',
    alignItems: 'center',
    justifyContent: 'start',
    backgroundColor: '#ffffff',
    color: '#b826ae',
    border: '1px solid #c02ca9',
    borderRadius: '14px',
    boxShadow: 'none',
    minWidth: '365px',
    maxWidth: '400px',
    maxHeight: '250px',
    overflow: 'auto',
    boxSizing: 'border-box',
    '& .MuiMenuItem-root': {
      minHeight: 'unset',
      minWidth: 0,
      padding: '0 !important',
      margin: '0 !important',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    '& .MuiChip-deleteIcon': {
      color: '#b02a9f',
      background: 'none',
      fontSize: '18px',
    },
  },
  popperClose: {
    position: 'absolute',
    top: 4,
    right: 4,
    zIndex: 1,
    padding: 4,
    color: '#b826ae',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#b826ae',
    },
  },
  chipitem: {
    height: "32px",
    width: '100px',
    boxSizing: "border-box",
    margin: 0,
    backgroundColor: "#e0e0e0",
    color: "#2d2828",
    borderRadius: "10px",
    fontSize: "11px",
    fontWeight: 600,
  },
  chipLabel: {
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // overflow: 'visible',
    lineHeight: '16px',
    padding: '6px 8px',
  },
  singlechipLabel: {
    textOverflow: 'none',
    position: 'relative',
    bottom: '8px',
  },
  listitem: {
    listStyle: "none",
    margin: "2px",
    padding: "0",
    minWidth: 0,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    boxSizing: "border-box",

    "& .MuiChip-root": {
      margin: "0",
      maxWidth: "100%",
      boxSizing: "border-box",
    },

    "& .MuiChip-deleteIcon": {
      color: "#b02a9f",
      background: "none",
      fontSize: "18px",
    },
  },

  // listitem: {
  //   listStyle: 'none',
  //   margin: '2px',
  //   padding: '0',
  //   '&.MuiChip-root': {
  //     margin: '2px',
  //   },
  //   '& .MuiChip-deleteIcon': {
  //     color: '#b02a9f',
  //     background: 'none',
  //     fontSize: '18px',
  //   },
  // },
}));

const Sampledata = [
  { key: 0, label: 'Store01' },
  { key: 1, label: 'Store02' },
  { key: 2, label: 'Store03' },
  { key: 3, label: 'Store04' },
  { key: 4, label: 'Store05' },
]
export default function DropdownChip(props) {
  const {
    open = false,
    setOpen = () => { },
    SelectedData = [],
    onChange = () => "",
    multiple = false,
    remainItems = [],
    totalchip = 0,
    inventoryType = "store",
  } = props
  const classes = useStyles()
  const MenudropdownRef = React.useRef(null)
  const totalChecked = SelectedData.concat(remainItems)
  const [chipData, setChipData] = React.useState(SelectedData || []);
  const [hovered, setHovered] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuDelete, setDelete] = React.useState(null)
  const setMoreAnchor = React.useCallback((node) => {
    setAnchorEl((current) => (current === node ? current : node))
  }, [])
  const anchorInDocument = Boolean(
    anchorEl &&
    anchorEl.ownerDocument &&
    anchorEl.ownerDocument.documentElement.contains(anchorEl)
  )
  const remainLength = multiple
    ? Math.max(0, totalchip - SelectedData.length)
    : 0;
  React.useEffect((prev) => {
    setChipData(SelectedData || [])
  }, [SelectedData, chipData])

  const handleClickAway = (event) => {
    setHovered(false)
  }
  const handleDelete = (chipToDelete) => () => {
    const updatedChipitems = chipData.filter((chip) => chip.id !== chipToDelete.id)
    setChipData(updatedChipitems)
    onChange(updatedChipitems)
  };
  const handleMultiDelete = (chipToDelete) => () => {
    const updatedChipitems = totalChecked.filter((chip) => chip.id !== chipToDelete.id)
    console.log(`updatedchip`, updatedChipitems)
    setChipData([...updatedChipitems, remainItems[0]])
    remainItems.shift()
    onChange(updatedChipitems)
  }
  console.log(`rem`, remainItems)
  return (
    <Box
      className={classes.ListBox}
      component="ul"
    >
      {
        !open && multiple ? (
          <button
            style={{
              display: 'inline-block',
              cursor: 'pointer',
              backgroundColor: '#b13db1',
              color: '#fff',
              borderRadius: '100%',
              width: '36px',
              border: 'none',
              height: '33px',
              padding: '5px',
            }}
            onClick={(e) => { setOpen(true) }}>
            <Tooltip
              placement="top"
              title={`Add more ${inventoryType}`} >
              < Add />
            </Tooltip>
          </button>

        ) : null
      }
      {
        chipData.map((data) => {
          return (
            <li className={classes.listitem}
              key={data.id} >
              <Tooltip placement="top" title={`${data?.name}`}>
                <Chip
                  className={multiple ? classes.chipitem : classes.singlechipLabel}
                  label={data.name}
                  onDelete={multiple && remainItems.length > 0 ? handleMultiDelete(data) : handleDelete(data)
                  }
                />
              </Tooltip>
            </li>
          );
        })
      }
      {
        multiple && remainItems.length > 0 && (
          <span
            ref={setMoreAnchor}
            onClick={(e) => {
              setHovered(true);
              setAnchorEl(e.currentTarget);
            }}
            style={{ cursor: "pointer" }}
          >
            <Button style={{
              fontSize: '15px',
              color: '#b826ae',
              whiteSpace: 'nowrap',
              fontWeight: 500
            }}> +{remainItems.length} More
            </Button>
            <Popper
              ref={MenudropdownRef}
              open={hovered && anchorInDocument}
              anchorEl={anchorEl}
              placement="bottom-end"
              style={{ zIndex: 1500, marginTop: '8px', }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <div style={{ position: 'relative' }}>
                  <IconButton
                    type="button"
                    aria-label="Close"
                    className={classes.popperClose}
                    onClick={(event) => {
                      event.stopPropagation()
                      setHovered(false)
                    }}
                  >
                    <IconsGallery.CloseIcon fontSize="small" />
                  </IconButton>
                  <Paper
                    elevation={0}
                    className={classes.MenuPaper}>
                    {remainItems.map((item, index) => (
                      <MenuItem key={item?.id || index}
                        className={classes.listitem}
                      >
                        <Tooltip placement="top" title={`${item?.name}`}  >
                          <Chip
                            className={classes.chipitem}
                            classes={{
                              label: classes.chipLabel,
                            }}
                            label={item.name}
                            onDelete={multiple && remainItems.length > 0 ? handleMultiDelete(item) : handleDelete(item)}
                          />
                        </Tooltip>
                      </MenuItem>
                    ))}
                  </Paper>
                </div>
              </ClickAwayListener>
            </Popper>
          </span>
        )
      }
    </Box >
  );
}